<template>
  <v-text-field
    class="form-registration__field"
    color="#0489E0"
    height="47"
    outlined
    v-bind:error-messages="inputErrors"
    v-bind:label="label"
    v-bind:type="inputType"
    v-model="password"
  >
    <template #append>
      <button
        class="field__icon"
        type="button"
        v-bind:class="{ field__icon_active: isShow }"
        v-on:click="toggle"
      />
    </template>
  </v-text-field>
</template>

<script>
/**
 * @description Поле ввода пароля.
 * @returns {any}
 */
export default {
  computed: {
    inputType: ({ isShow }) => (isShow ? 'text' : 'password'),
    isError: ({ inputErrors }) => inputErrors.length > 0,
  },
  data() {
    return {
      /**
       * @description Пароль.
       * @type {string}
       */
      password: this.value,
      /**
       * @description Показывать пароль.
       * @type {bool}
       */
      isShow: false,
    };
  },
  methods: {
    /**
     * @description Переключить показ пароля.
     * @returns {void}
     */
    toggle() {
      this.isShow = !this.isShow;
    },
  },
  props: {
    /**
     * @description Нарушения ограничений.
     * @type {any}
     */
    inputErrors: { required: true, type: Array },
    /**
     * @description Метка.
     * @type {string}
     */
    label: { required: true, type: String },
    /**
     * @description Значение.
     * @type {string}
     */
    value: { required: true, type: String },
  },
  watch: {
    password(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style scoped lang="scss">
.field {
  &__icon {
    background-image: url("@/assets/img/eye-closed.svg");
    background-position: center;
    cursor: pointer;
    height: 26px;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 26px;
    &_active {
      background-image: url("@/assets/img/eye-open.svg");
    }
  }
}
</style>
